<template>
    <v-dialog 
        :value="isOpen" 
        max-width="600px" 
        transition="slide-y-transition" 
        eager 
        @keydown.esc="onClose" 
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Nowości w wersji <strong>{{ latestVersion && latestVersion.number }}</strong>:
                </h1>
            </v-card-title>

            <v-card-text>
                <v-list v-if="latestVersion && latestVersion.changes" dense>
                    <v-list-item v-for="(change, index) in sortedChanges" :key="change.id">
                        <v-list-item-icon>
                            <span class="font-weight-medium">{{ index + 1 }}.</span>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title style="white-space: normal; word-break: break-word;">
                                {{ change.description }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text data-sentry-label="Zamknij" @click="onClose">
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ReleaseNotesDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        latestVersion: {
            type: Object,
            default: null
        }
    },
    computed: {
        sortedChanges() {
            if (!this.latestVersion || !this.latestVersion.changes) {
                return []
            }

            return [...this.latestVersion.changes].sort((a, b) => a.sortOrder - b.sortOrder)
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
